import { API_URLS } from 'app-constants/api';
import secondaryHttpService from 'services/secondary-http.service';
import { ApiRequest } from 'types';

export const getValidationRules = (): ApiRequest => () => {
  return secondaryHttpService.get(API_URLS.validationRules(), {});
};

export const postValidationRule =
  (data: any): ApiRequest =>
  () => {
    return secondaryHttpService.post(API_URLS.validationRules(), data);
  };

export const editValidationRule =
  (data: any, id: any): ApiRequest =>
  () => {
    return secondaryHttpService.put(API_URLS.validationRules(), data);
  };
